/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import '@/vlinder.min.css';

import {
  ProgressBar,
  BodyContainer,
  BodyTitle,
  PolicyOptions,
  PolicyPreview,
  PaymentComp,
  PolicyPurchaseStatus,
  TermsofUse,
  VerificationModal,
  IntendedPurpose,
  PaymentMethod,
  KYCForm,
  LoadingContainer,
  PhoneVerificationModal,
} from '../components';
import { HtmlPage as HtmlPageWidget } from '@widgets/landing-page-widget';
import { BuyInsurancePageService } from '@pages/BuyInsurancePage/services';
import { vappContainer } from '@/application';
import moment from 'moment';

import { LeftContainer, RightContainer, SubmitButton } from '../components';
import {
  useSMverifyOTP,
  useSMGetKYCData,
  useSMcreatePolicy,
  useSMsubmitKYC,
  useSMSendOTP,
  //   useSMVerifyPhoneOTP,
  //   useSMGetOffer,
} from '../machines/';

import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { routes } from '@/AppNavigator/services/config/routes.config';

const getSrv = () => {
  return vappContainer.get<BuyInsurancePageService>(
    BuyInsurancePageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const [activeStep, setActiveStep] = useState(0);
  const [country, setCountry] = useState<'in'>('in');
  const [buttonItem, setButtonItem] = useState();
  const [email, setEmail] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [showOTPModal, setShowOTPModal] = useState<boolean>(false);
  const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false);
  const [showPhoneOTPModal, setShowPhoneOTPModal] = useState<boolean>(false);
  const [policyOpts, setPolicyOpts] = useState([]);
  const [reloadHeader, setReloadHeader] = useState<boolean>(false);
  const [coverage, setCoverage] = useState<number>();
  const [disablePurchase, setDisablePurchase] = useState(false);
  const [showPolicySuccess, setShowPolicySuccess] = useState(false);

  const navigate = useNavigate();
  const theme = useTheme();

  const srv = getSrv();

  useEffect(() => {
    async function getNavItems() {
      let _navlinks = await srv?.agent?.getHeaderNavContent();
      if (_navlinks) {
        setButtonItem(_navlinks);
      }
    }
    setTimeout(() => {
      getNavItems();
    }, 500);
  }, [activeStep, reloadHeader]);

  const { kycDataMachine, kycDataSend, kycDataState } = useSMGetKYCData({});
  const { submitKYCMachine, submitKYCSend, submitKYCState } = useSMsubmitKYC(
    {}
  );
  const { sendOTPMachine, sendOTPSend, sendOTPState } = useSMSendOTP({});
  const { createPolicyMachine, createPolicySend, createPolicyState } =
    useSMcreatePolicy({});

  useEffect(() => {
    if (
      createPolicyState?.matches('CREATE_POLICY_SUCCESS') &&
      createPolicyState?.event?.data?.value
    ) {
      const timer = setTimeout(() => {
        setShowPolicySuccess(true);
      }, 2500);
      return () => clearTimeout(timer);
    } else {
      setShowPolicySuccess(false);
    }
  }, [createPolicyState]);

  useEffect(() => {
    if (showPolicySuccess) {
      const timer = setTimeout(() => {
        onViewPolicyClick();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showPolicySuccess]);

  useEffect(() => {
    if (createPolicyState?.matches('CREATE_POLICY_FAILED')) {
      const timer = setTimeout(() => {
        navigate(routes?.MyAccount?.path || '/my-profile');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [createPolicyState]);

  const onActiveStepChange = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const onStepperClose = () => {
    srv?.resetFormData();
    props?.onCloseClick && props?.onCloseClick();
  };

  const onOTPSubmit = (data: any) => {
    setShowOTPModal(false);
    // setActiveStep(activeStep + 1);
    kycDataSend('VERIFY_OTP', {
      payload: {
        email: email,
        otp: data?.otp,
      },
    });
  };

  const onResendOTP = () => {
    kycDataSend('SEND_OTP', {
      payload: {
        email: email,
      },
    });
  };

  const onModalClose = () => {
    if (showOTPModal) {
      setShowOTPModal(!showOTPModal);
      window.location.reload();
    }
    if (showPhoneOTPModal) {
      setShowPhoneOTPModal(!showPhoneOTPModal);
    }
  };

  const _renderOTPModal = () => {
    if (
      (kycDataState?.matches('SUBMIT_OTP') ||
        kycDataState?.matches('SUBMIT_OTP_FAILED')) &&
      showOTPModal &&
      activeStep === 2
    ) {
      return (
        <VerificationModal
          showModal={true}
          onOTPSubmit={onOTPSubmit}
          resendOtpClick={onResendOTP}
          email={email}
          phoneNumber={
            kycDataState?.event?.data?.value?.smsSent
              ? kycDataState?.event?.data?.value?.primaryContactNo
              : null
          }
          onDeny={onModalClose}
        />
      );
    }
    // if (showPhoneOTPModal && activeStep === 8) {
    //   return (
    //     <PhoneVerificationModal
    //       showModal={true}
    //       onOTPSubmit={onPhoneOTPSubmit}
    //       resendOtpClick={resendPhoneOTP}
    //       phoneNumber={createPolicyState?.event?.data?.value?.phoneNumber}
    //       onDeny={onModalClose}
    //     />
    //   );
    // }
  };

  const onPolicyOptionSubmit = (policy: any) => {
    srv.setPolicyDetail(policy);
    // toast.success('coming soon');

    // if(getOfferState?.event?.data?.value?.canPurchase){
    setActiveStep(activeStep + 1);
    kycDataSend('START', {});
    window.scrollTo(0, 0);
    // }
    // else {
    //   setDisablePurchase(true);
    // }
  };

  const onSliderValueChange = (key: string, value: number) => {
    console.log(`slider value change`, key, value);
    let policyDetails = [];
    if (key === 'Coverage') {
      policyDetails = srv?.agent?.coverageToPremiumSync({
        country: country,
        coverage: value,
      });
      setCoverage(value);
    }
    if (key === 'Premium') {
      policyDetails = srv?.agent?.premiumToCoverageSync({
        country: country,
        premium: value,
      });
    }
    setPolicyOpts(policyDetails?.policyOptions);
    srv.onPolicyOptionChange(value);
  };

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const onPreviewSubmit = () => {
    window.scrollTo(0, 0);
    setActiveStep(activeStep + 1);
  };

  const onEmailKYCSubmit = (data: any) => {
    setEmail(data?.email);
    setShowOTPModal(true);
    kycDataSend('SEND_OTP', {
      payload: data,
    });
  };

  const onKYCSubmit = (formData: any) => {
    srv?.setKYCFormData(formData);
    if (
      formData?.idProofType ||
      formData?.addressProofType ||
      formData?.firstName
    ) {
      submitKYCSend('START', {
        payload: formData,
      });
    }
    if (kycDataState?.event?.data?.value) {
      let _email = kycDataState?.event?.data?.value?.policyHolder?.email;
      setEmail(_email);
    }
    window.scrollTo(0, 0);
    setActiveStep(activeStep + 1);
  };

  const _getPreviewData = () => {
    let _previewData = srv?.getPolicyPreviewData();
    let _policyHolder = {
      ..._previewData?.policyHolder,
    };

    return (
      <PolicyPreview
        onPolicyPreviewSubmit={onPreviewSubmit}
        beneficiary={_previewData?.beneficiary}
        policyHolder={_policyHolder}
        policySelected={_previewData?.policyData}
        // coverage={coverage}
        // country={country}
        // headers={staticPageContentConfig?.policyPayoutHeaders?.headers}
      />
    );
  };

  const onVerifyPhoneClick = () => {
    //   if (!showPhoneOTPModal) {
    //     setShowPhoneOTPModal(true);
    //   }
    //   sendOTPSend("START", {
    //     payload: {
    //       email: createPolicyState?.event?.data?.value?.email,
    //       sendOn: "sms",
    //     },
    //   });
  };

  const _renderKYCForm = () => {
    if (
      kycDataState.matches('CHECK_USER_LOGIN') ||
      kycDataState.matches('USER_LOGIN_SUCCESS')
    ) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticContentSync()?.loading?.GetPageLoading ||
            {})}
        />
      );
    }
    if (kycDataState.matches('SEND_EMAIL_OTP')) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticContentSync()?.loading?.GetPageLoading ||
            {})}
        />
      );
    }
    if (
      kycDataState.matches('VERIFY_OTP') ||
      kycDataState.matches('GET_ACCESS_TOKEN')
    ) {
      return (
        <StateOSD
          {...(srv?.agent?.getStaticContentSync()?.loading?.verifyOTP || {})}
        />
      );
    }
    if (kycDataState.matches('VERIFY_OTP_FAILED')) {
      if (!showOTPModal) {
        setShowOTPModal(true);
      }
    }
    if (kycDataState.matches('USER_IS_NOT_LOGGED_IN')) {
      return (
        <>
          <BodyTitle
            {...(srv.agent?.getStaticContentSync()?.bodyTitle?.kycForm || {})}
          />
          <KYCForm
            emailKYCFields={srv.agent?.getStaticContentSync()?.emailKyc?.fields}
            emailKYCLayout={srv.agent?.getStaticContentSync()?.emailKyc?.layout}
            isEmailVerified={false}
            renderSubmitButton={renderSubmitButton}
            onEmailSubmit={onEmailKYCSubmit}
          />
        </>
      );
    }
    if (kycDataState.matches('KYC_FORM_DATA_SUCCESS')) {
      if (!reloadHeader) {
        setReloadHeader(true);
      }
      return (
        <>
          <BodyTitle
            {...(srv.agent?.getStaticContentSync()?.bodyTitle?.kycForm || {})}
          />
          <KYCForm
            kycFormFields={kycDataState?.event?.data?.value?.FIELDS}
            kycFormLayout={kycDataState?.event?.data?.value?.layout}
            kycFormValidator={kycDataState?.event?.data?.value?.validatorConfig}
            kycFormInitialData={{ ...srv?.getKYCFormData() }}
            renderSubmitButton={renderSubmitButton}
            onKYCSubmit={onKYCSubmit}
            isEmailVerified={true}
          />
        </>
      );
    }
  };

  const getPolicyOptions = () => {
    let _defaultAmount = srv?.getDefaultPolicy();
    return (
      <>
        <LeftContainer>
          <PolicyOptions
            onPolicySubmit={onPolicyOptionSubmit}
            onSliderValueChange={onSliderValueChange}
            options={policyOpts}
            initialAmount={_defaultAmount}
            country={country}
            selectedPolicy={{}}
            // headers={srv.agent?.getStaticContentSync()?.policyPayoutHeaders?.headers}
          />
        </LeftContainer>
        <RightContainer
          rightBlockContent={
            srv?.agent.getStaticContentSync()?.rightBlockContent?.policyOption
          }
        />
      </>
    );
  };

  const onViewPolicyClick = () => {
    if (props?.onViewPolicyClick) {
      props.onViewPolicyClick();
    } else {
      navigate(routes?.MyAccount?.path || '/my-profile');
    }
  };

  const onDOBSubmit = (data: any) => {
    if (data?.dob) {
      srv?.setDateOfBirth(data?.dob);
      
      let today = new Date();
      
      let _diff = moment(today).diff(moment(data?.dob), 'years');
      console.log('difference bw years', _diff);
      if (_diff < 18 || _diff > 65) {
        toast.error(
          '	Minimum Age 18 or Maximum age 65 years criteria not matching for insurance purchase'
        );
      } else {
        setActiveStep(activeStep + 1);
      }
    }
    // setActiveStep(activeStep+1);
  };

  const _getPolicyStatus = () => {
    if (
      createPolicyState?.matches('CREATE_POLICY_SUCCESS') &&
      createPolicyState?.event?.data?.value
    ) {
      if (!showPolicySuccess) {
        return (
          <LoadingContainer>
            <StateOSD
              {...(srv?.agent?.getStaticContentSync()?.loading?.policyIssuing ||
                srv?.agent?.getStaticContentSync()?.loading?.purchasePolicy ||
                {})}
            />
          </LoadingContainer>
        );
      }
      srv.resetFormData();
      return (
        <PolicyPurchaseStatus
          {...(srv?.agent?.getStaticContentSync()?.policyStatus || {})}
          policyNumber={createPolicyState?.event?.data?.value?.policyNumber}
          buttonTitle="Go to My Profile"
          onButtonClick={onViewPolicyClick}
          email={createPolicyState?.event?.data?.value?.email}
          verifyPhone={!createPolicyState?.event?.data?.value?.phoneVerified}
          premium={createPolicyState?.event?.data?.value?.premium}
          discountPremium={createPolicyState?.event?.data?.value?.discount}
          // isDiscounted={getOfferState?.event?.data?.value?.applicable}
          onVerifyPhoneClick={onVerifyPhoneClick}
        />
      );
    }

    if (createPolicyState?.matches('CREATE_POLICY_FAILED')) {
      return (
        <LoadingContainer>
          <StateOSD
            image="https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/sad-face-fhp.png"
            titleNormalText="Payment could not be completed"
            titleBoldText="."
            description="Transaction was cancelled or encountered an error. Redirecting to My Profile..."
          />
          <div className="text-center mt-3">
            <button
              className="btn btn-secondary text-dark"
              onClick={() => navigate(routes?.MyAccount?.path || '/my-profile')}
            >
              Go to My Profile
            </button>
          </div>
        </LoadingContainer>
      );
    }

    return (
      <LoadingContainer>
        <StateOSD
          {...(srv?.agent?.getStaticContentSync()?.loading?.paymentProcessing ||
            srv?.agent?.getStaticContentSync()?.loading?.purchasePolicy ||
            {})}
        />
      </LoadingContainer>
    );
  };

  const onPaymentTypeSubmit = (type: string) => {
    let _previewData = srv?.getPolicyPreviewData();
    console.log(`_preview Data`, _previewData);
    let _policyHolder = {
      ..._previewData?.policyHolder,
      email: _previewData?.policyHolder?.email ?? email,
    };
    if (!_policyHolder?.firstName) {
      _policyHolder = srv?.getKYCFormData();
      console.log('policy holder', _policyHolder);
    }
    if (type === 'online') {
      setShowPolicySuccess(false);
      createPolicySend('START', {
        payload: {
          nominee: _previewData?.beneficiary,
          holder: _policyHolder,
          policy: _previewData?.policyData,
          coverage: coverage,
        },
      });
      setActiveStep(activeStep + 1);
    }
  };

  const getDateOfBirthForm = () => {
    console.log(`dob config`, srv?.agent.getStaticContentSync()?.dobConfig);
    return (
      <>
        <LeftContainer>
          <BodyTitle
            {...(srv?.agent.getStaticContentSync()?.bodyTitle?.selectCountry ||
              {})}
          />
          <TweetyWidget
            labelColor={theme.colors.orangePrimary}
            fields={srv?.agent?.getStaticContentSync()?.dobConfig?.FIELDS}
            layout={srv?.agent?.getStaticContentSync()?.dobConfig?.layout}
            validatorConfig={
              srv?.agent?.getStaticContentSync()?.dobConfig?.validatorConfig
            }
            onFormSubmit={onDOBSubmit}
            renderSubmitButton={renderSubmitButton}
          />
        </LeftContainer>
        <RightContainer
          rightBlockContent={
            srv?.agent.getStaticContentSync()?.rightBlockContent?.selectCountry
          }
        />
      </>
    );
  };

  const _renderBody = () => {
    switch (activeStep) {
      case 0:
        return getDateOfBirthForm();
      case 1:
        return getPolicyOptions();
      case 2:
        return (
          <>
            <LeftContainer>{_renderKYCForm()}</LeftContainer>
            <RightContainer
              rightBlockContent={
                srv?.agent.getStaticContentSync()?.rightBlockContent?.kycForm
              }
            />
          </>
        );
      case 3:
        return (
          <>
            <LeftContainer>
              <BodyTitle
                {...(srv?.agent.getStaticContentSync()?.bodyTitle?.preview ||
                  {})}
              />
              {_getPreviewData()}
            </LeftContainer>
            <RightContainer
              rightBlockContent={
                srv?.agent.getStaticContentSync()?.PolicyOptions
              }
            />
          </>
          //   <>
          //     <LeftContainer>
          //       <BodyTitle
          //         {...(srv.agent?.getStaticContentSync()?.bodyTitle?.kycForm ||
          //           {})}
          //       />
          //       <KYCForm
          //         kycFormFields={
          //           srv.agent?.getStaticContentSync()?.kycFormConfig?.FIELDS
          //         }
          //         kycFormLayout={
          //           srv.agent?.getStaticContentSync()?.kycFormConfig?.layout
          //         }
          //         kycFormValidator={
          //           srv.agent?.getStaticContentSync()?.kycFormConfig
          //             ?.validatorConfig
          //         }
          //         kycFormInitialData={{ ...srv?.getKYCFormData() }}
          //         renderSubmitButton={renderSubmitButton}
          //         onKYCSubmit={onKYCSubmit}
          //         isEmailVerified={true}
          //       />
          //     </LeftContainer>
          //     <RightContainer
          //       {...(srv?.agent.getStaticContentSync()?.rightBlockConfig
          //         ?.kycForm || {})}
          //     />
          //   </>
        );
      case 4:
        return (
          <>
            <LeftContainer>
              <BodyTitle
                {...(srv?.agent.getStaticContentSync()?.bodyTitle
                  ?.paymentMethod || {})}
              />
              <PaymentMethod onPaymentTypeSubmit={onPaymentTypeSubmit} />
            </LeftContainer>
            <RightContainer />
          </>
        );
      case 5:
        return <>{_getPolicyStatus()}</>;
      case 6:
        return <></>;
      default:
        return null;
    }
  };

  return (
    <>
      <HtmlPageWidget
        {...srv?.agent.getStaticContentSync()}
        buttonItem={buttonItem}
      >
        <ProgressBar
          onActiveStepChange={onActiveStepChange}
          activeStep={activeStep}
          totalSteps={6}
          onCloseClick={onStepperClose}
        />
        {/* {_renderNotifications()} */}
        {_renderOTPModal()}
        {/* {_renderErrorNotification()} */}
        <BodyContainer>{_renderBody()}</BodyContainer>
      </HtmlPageWidget>
    </>
  );
};
